export default "__VITE_ASSET__DhAZU4Uy__"